export const COOKIES = {
  ADOBE_MC_VISITOR_COOKIE_KEY: 'AMCV_05FF6243578784B37F000101%40AdobeOrg',
  ANOMYMOUS_SELLER_DRAFT_COOKIE_KEY: 'anonymousSellerDraft',
  AD_NOT_AVAILABLE: 'AdNotAvailable',
  BLOCKED_USERS_KEY: 'blocked_users',
  COOKIE_CMP_KEY: 'euconsent-v2',
  FAVORITE_SHARE_MODAL_COOKIE: 'isFavoriteShareDisabled',
  HAS_SEEN_HOME_POST_CONSENT_LOGIN: 'hasSeenHomePostConsentLogin',
  HAS_SEEN_SAVE_NEWS_COACHMARK: 'hasSeenSaveNewsCoachmark',
  HAS_VISITED_SAVED_NEWS_TAB: 'hasVisitedSavedNewsTab',
  IMPERVA_TOKEN_COOKIE_KEY: 'reese84',
  IS_VIEWED_ONBOARDING_ALERT_NEW_CATEGORY: 'isViewedOnboardingAlertNewCategory',
  IS_VIEWED_SORT_MANAGEMENT_NOTIFICATION: 'isViewedSortManagementNotification',
  IS_VIEWED_ZERO_RESULTS_TOOLTIP: 'isViewedZeroResultsTooltip',
  SEGMENT_ANONYMOUS_COOKIE_KEY: 'ajs_anonymous_id',
  SEGMENT_USER_ID_COOKIE_KEY: 'ajs_user_id',
  VISITED_AD: 'visitedAd'
}

export const COOKIE_EXPIRATIONS = {
  ONE_YEAR: 365
}
